// tags.js — the tag menu. The chosen tag is applied to new tasks AND narrows
// what Next draws (one control on purpose: you add the category you're about
// to work in).

import { S } from './state.js';
import { saveTags } from './local.js';
import { saveAll } from './sync.js';

const tagBtn = document.getElementById('tagBtn');
const tagMenu = document.getElementById('tagMenu');
const existingTags = document.getElementById('existingTags');
const newTagInput = document.getElementById('newTagInput');

function setSelectedLabel() {
  const label = document.getElementById('selectedAddTag');
  if (label) label.textContent = S.currentAddTag ? `[${S.currentAddTag}]` : '';
}

function closeMenu() { tagMenu.style.display = 'none'; tagBtn.setAttribute('aria-expanded', 'false'); }
function openMenu() { renderTagList(); tagMenu.style.display = 'block'; tagBtn.setAttribute('aria-expanded', 'true'); }

export function renderTagList() {
  if (!existingTags || !tagMenu) return;
  existingTags.innerHTML = '';

  // Build the options with DOM APIs so tag names are never parsed as HTML.
  const makeRadio = (value) => {
    const r = document.createElement('input');
    r.type = 'radio'; r.name = 'tagOption'; r.value = value;
    r.checked = S.currentAddTag === value;
    return r;
  };

  const noneLabel = document.createElement('label');
  noneLabel.appendChild(makeRadio(''));
  noneLabel.appendChild(document.createTextNode(' No tag'));
  existingTags.appendChild(noneLabel);

  S.tags.forEach(tag => {
    const label = document.createElement('label');
    label.className = 'tag-option';
    const span = document.createElement('span');
    span.appendChild(makeRadio(tag));
    span.appendChild(document.createTextNode(' ' + tag));
    const delBtn = document.createElement('button');
    delBtn.className = 'delete-tag';
    delBtn.type = 'button';
    delBtn.dataset.tag = tag;
    delBtn.textContent = '×';
    delBtn.setAttribute('aria-label', `Delete tag: ${tag}`);
    label.appendChild(span);
    label.appendChild(delBtn);
    existingTags.appendChild(label);
  });

  existingTags.querySelectorAll('.delete-tag').forEach(btn => {
    btn.addEventListener('click', () => {
      const t = btn.dataset.tag;
      S.tags = S.tags.filter(x => x !== t);
      saveTags();
      if (S.currentAddTag === t) S.currentAddTag = '';
      setSelectedLabel();
      renderTagList();
      saveAll();
    });
  });

  existingTags.querySelectorAll('input[name="tagOption"]').forEach(radio => {
    radio.addEventListener('change', () => {
      const selected = document.querySelector('input[name="tagOption"]:checked');
      S.currentAddTag = selected?.value || '';
      setSelectedLabel();
      closeMenu();
    });
  });
}

export function initTagMenu() {
  tagBtn.addEventListener('click', () => {
    if (tagMenu.style.display === 'block') closeMenu(); else openMenu();
  });

  newTagInput.addEventListener('keydown', e => {
    if (e.key !== 'Enter') return;
    e.preventDefault();
    const newTag = newTagInput.value.trim();
    if (newTag && !S.tags.includes(newTag)) {
      S.tags.push(newTag);
      S.tags.sort((a, b) => a.localeCompare(b));
      saveTags();
      newTagInput.value = '';
      S.currentAddTag = newTag;
      renderTagList();
      setSelectedLabel();
      saveAll();
    }
    closeMenu();
  });

  // Click outside closes the menu
  document.addEventListener('click', e => {
    if (tagMenu.style.display === 'block' && !tagMenu.contains(e.target) && e.target !== tagBtn) closeMenu();
  });
}
